import React from "react";
import { mapStore } from "../../../../stores/mobx/mapStore";
import {
  addMarkersToLayer,
  findLayer,
} from "../../../../utils/helpers/mapMarkerHelpers";
import HookupLayers from "./HookupLayers";
import "./style.scss";

const HookupPoints = ({ hookupPointsParsed, workLogId }) => {
  const handleHookupPointsMapToggling = (e, hookupName) => {
    const hookupPointsLayer = findLayer(
      mapStore.getMapRef,
      "HOOKUP_POINTS_LAYER"
    );
    const hookupPointsMarkerLayerGroup = HookupLayers(
      hookupPointsParsed,
      hookupName,
      workLogId
    );
    if (e.target.checked) {
      addMarkersToLayer(hookupPointsMarkerLayerGroup, hookupPointsLayer);
    } else {
      hookupPointsLayer.eachLayer((layer) => {
        if (layer.id === `${hookupName}-${workLogId}`) {
          layer.clearLayers();
        }
      });
    }
  };
  const hookupPoints = Object.keys(hookupPointsParsed).map((hookupName) => {
    let coordinatesCount = hookupPointsParsed[hookupName].coordinates.length;

    return (
      <div className="hookup-input" key={hookupName}>
        <input
          data-testid=""
          className="hookup-checkbox"
          type="checkbox"
          onChange={(e) => handleHookupPointsMapToggling(e, hookupName)}
        />
        {hookupName}: ({coordinatesCount})
      </div>
    );
  });

  return (
    hookupPointsParsed && (
      <div className="hookup-points">
        <div className="hookup-title">Hookup Points</div>
        {hookupPoints}
      </div>
    )
  );
};

export default HookupPoints;
